import { render } from "./ReviewFeedbackModal.vue?vue&type=template&id=18cb4867&scoped=true"
import script from "./ReviewFeedbackModal.vue?vue&type=script&lang=js"
export * from "./ReviewFeedbackModal.vue?vue&type=script&lang=js"

import "./ReviewFeedbackModal.vue?vue&type=style&index=0&id=18cb4867&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cb4867"]])

export default __exports__